import { Box, css } from '@mui/material'

import { useMQ } from '../hooks/useMQ'
import combineStyles from '../utils/combineStyles'
import { HumaScrollAnimation } from './HumaScrollAnimation'
import EmergingEurope500 from './images/backed-by-500-emerging-europe.png'
import Anagram from './images/backed-by-anagram.png'
import BlockchainFoundersFund from './images/backed-by-blockchain-founders-fund.png'
import Circle from './images/backed-by-circle.png'
import DistributedGlobal from './images/backed-by-dg.png'
import FenbushiCapital from './images/backed-by-fenbushi.png'
import FoliusVentures from './images/backed-by-folius.png'
import HardYaka from './images/backed-by-hard-yaka.png'
import HashkeyCapital from './images/backed-by-hashkey.png'
import ParafiCapital from './images/backed-by-parafi.png'
import RaceCapital from './images/backed-by-race.png'
import RobotVentures from './images/backed-by-robot.png'
import SantiagoSantos from './images/backed-by-santiago-santos.png'
import Stellar from './images/backed-by-stellar.png'
import TurkiyeBankasi from './images/backed-by-turkiye-bankasi.png'
import { Title } from './Title'

export function BackedBy() {
  const { isXsSize, isBelowXsSize } = useMQ()

  const backedBys = [
    {
      logo: DistributedGlobal,
      iconHeight: isBelowXsSize ? 28 : 64,
      type: 'image',
    },
    {
      logo: HashkeyCapital,
      iconHeight: isBelowXsSize ? 16 : 31,
      type: 'image',
    },
    {
      logo: FoliusVentures,
      iconHeight: isBelowXsSize ? 14 : 27,
      type: 'image',
    },
    {
      logo: ParafiCapital,
      iconHeight: isBelowXsSize ? 17.8 : 42,
      type: 'image',
    },
    {
      logo: Circle,
      iconHeight: isBelowXsSize ? 15.2 : 38,
      type: 'image',
    },
    {
      logo: RobotVentures,
      iconHeight: isBelowXsSize ? 21 : 48,
      type: 'image',
    },
    {
      logo: FenbushiCapital,
      iconHeight: isBelowXsSize ? 13 : 34,
      type: 'image',
    },
    {
      logo: Anagram,
      iconHeight: isBelowXsSize ? 48 : 80,
      type: 'image',
    },
    {
      logo: HardYaka,
      iconHeight: isBelowXsSize ? 12 : 21,
      type: 'image',
    },
    {
      logo: Stellar,
      iconHeight: isBelowXsSize ? 24 : 49,
      type: 'image',
    },
    {
      logo: TurkiyeBankasi,
      iconHeight: isBelowXsSize ? 24 : 45,
      type: 'image',
    },
    {
      logo: RaceCapital,
      iconHeight: isBelowXsSize ? 20 : 32,
      type: 'image',
    },
    {
      logo: EmergingEurope500,
      iconHeight: isBelowXsSize ? 27.5 : 57,
      type: 'image',
    },
    {
      logo: BlockchainFoundersFund,
      iconHeight: isBelowXsSize ? 29 : 57,
      type: 'image',
    },
    {
      logo: SantiagoSantos,
      iconHeight: isBelowXsSize ? 17 : 36,
      type: 'image',
    },
  ]

  const getBackedByStyle = () => {
    if (isBelowXsSize) {
      return css`
        width: 100px;
        height: 40px;
        margin: 8px;
      `
    }
  }

  const getBackedByPersonStyle = () => {
    if (isBelowXsSize) {
      return css`
        height: 40px;
        font-size: 10px;
        line-height: 12px;
        text-align: center;
        letter-spacing: 0.15px;
      `
    }
  }

  const styles = {
    wrapper: css`
      width: 100%;
      z-index: 1;
      position: relative;
      margin-top: ${isXsSize ? '72px' : '160px'};
      margin-bottom: ${isXsSize ? '72px' : '128px'};
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    `,
    backedByWrapper: css`
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      max-width: 1100px;
      width: 100%;
    `,
    backedBy: css`
      width: 192px;
      height: 76px;
      color: white;
      margin: 8px;
      box-sizing: border-box;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      ${getBackedByStyle()}
    `,
    backedByPerson: css`
      width: 240px;
      height: 96px;
      font-weight: 700;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      line-height: 24px;
      color: #423b46;
      ${getBackedByPersonStyle()}
    `,
    bgBottom: css`
      position: absolute;
      width: 100%;
    `,
  }

  return (
    <HumaScrollAnimation>
      <Box css={styles.wrapper}>
        <Title title='Backed By' />
        <Box css={styles.backedByWrapper}>
          {backedBys.map((item, index) => {
            return (
              <Box key={index} css={combineStyles([styles.backedBy])}>
                {item.type === 'image' ? (
                  <img
                    src={item.logo}
                    alt='backedBy'
                    style={{ height: `${item.iconHeight}px` }}
                  />
                ) : (
                  <Box css={styles.backedByPerson}>{item.logo as string}</Box>
                )}
              </Box>
            )
          })}
        </Box>
      </Box>
    </HumaScrollAnimation>
  )
}
